<template>
  <div>
    <el-cascader filterable v-model="orgId" :options="organizationList" :props="{
      expandTrigger: 'hover',
      label: 'name',
      value: 'id',
      children: 'childs',
      checkStrictly: true,
    }" :placeholder="$t('message.scopeOfPersonnel')" @change="getAdmin" clearable></el-cascader>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: {
    org_id: { type: [Number, String] },
  },
  data() {
    return {
      orgId: [],
      e: "",
      list: [],
      userList: [],
    };
  },
  computed: {
    ...mapState(["organizationList"]),
  },
  mounted() {
    this.$nextTick(() => {
      if (this.org_id) {
        this.getAdmin([this.org_id]);
        this.getPOrgIds();
      } else {
        let orgId = JSON.parse(localStorage.getItem('orgId'))
        if (orgId) {
          this.orgId = orgId
          this.getAdmin(orgId);
        }
      }
    });
    // this.getAdmin(this.org_id);
  },
  methods: {
    // 找到全部id数组
    getPOrgIds() {
      this.$api.roleApi.getPOrgIds({ org_id: this.org_id }).then((res) => {
        this.orgId = res.data;
        // let orgId = JSON.parse(localStorage.getItem('orgId'))
        // if (orgId) {
        //   this.getAdmin(orgId);
        // }

      });
    },
    getAdmin(e) {
      this.e = e[e.length - 1];
      this.userList = [];
      this.inquire(this.organizationList);

      // this.getUserList(this.list);
      // 数组去重
      var hash = {};
      this.userList = this.userList.reduce(function (item, next) {
        hash[next.id]
          ? ""
          : (hash[next.id] = true && item.push(next));

        return item;
      }, []);
      let data = {
        id: this.e,
        userList: this.userList,
      };
      localStorage.setItem('orgId', JSON.stringify(e))
      this.$emit("setUserList", data);
    },
    // 查询组织
    inquire(list) {
      for (let i = 0; i < list.length; i++) {
        if (this.e == list[i].id) {
          this.list = list[i].childs;
          list[i].role.forEach((item) => {
            item.admin.forEach(items => {
              this.userList.push({
                name: items.realname,
                id: items.id,
              });
            })
          });
          return false;
        } else {
          this.inquire(list[i].childs);
        }
      }
    },
    // 多维人员拼接成一维
    getUserList(list) {
      console.log(list);
      for (let i = 0; i < list.length; i++) {
        list[i].role.forEach((item) => {
          item.admin.forEach(items => {
            this.userList.push({
              name: items.realname,
              id: items.id,
            });
          })

        });
        this.getUserList(list[i].childs);
      }
    },
  },
};
</script>
<style lang='scss' scoped>
/deep/.el-cascader {
  width: 100%;
}
</style>